export default __webpack_public_path__ + "static/media/clal.f12857fc.webp";